import React, { useContext, Dispatch, SetStateAction } from 'react';
import {
    IStackStyles,
    IStackTokens,
    Stack,
    Link,
    TooltipHost,
    ITooltipHostStyles,
} from '@fluentui/react';
import { useId } from '@uifabric/react-hooks';
import { Replication } from '../../models/Replication';
import { Deployment } from '../../models/Deployment';
import { Build } from '../../models/Build';
import { ThemeContext } from '../../../HubLayout/models/ThemeContext';
import { getThemeFromString } from '../../../Common/util/localStorageUtils';
import { emitUserActionMetric } from '../../../Common/util/metricsUtil';
import {
    ActionResult,
    ToggleMode,
    UserAction,
} from '../../../Common/Enums/Metrics/MetricEnums';
import { CompletionIndicatorIcon } from '../MultistageReleaseData/Display/Status/CompletionIndicatorIcon';
import { getCurrentStepName } from '../../util/ReleaseUtils';

interface IReplicationStatusDisplayProps {
    replication?: Replication;
    deployment: Deployment;
    setSelectedDeployment: Dispatch<
        SetStateAction<Deployment | Build | undefined>
    >;
    showPanel: () => void;
}

export const ReplicationStatusDisplay: React.FC<IReplicationStatusDisplayProps> =
    (props: IReplicationStatusDisplayProps) => {
        const themeContext = useContext(ThemeContext);
        const theme = getThemeFromString(themeContext.themeName);
        const stackTokens: IStackTokens = { childrenGap: 5 };
        const stackStyles: Partial<IStackStyles> = {
            root: {
                alignItems: 'center',
            },
        };
        const tooltipId = useId('status-tooltip');
        const hostStyles: Partial<ITooltipHostStyles> = {
            root: {
                display: 'inline-block',
            },
        };

        const onViewDetailsClick = (deployment: Deployment) => {
            props.setSelectedDeployment(deployment);
            props.showPanel();
            emitUserActionMetric(
                UserAction.DEPLOYMENT_FLYOUT,
                ToggleMode.TOGGLE,
                ActionResult.SUCCESS,
                process.env.REACT_APP_BUILD_VERSION
            );
        };

        return props.replication ? (
            <TooltipHost
                content="Click to open the flyout and view more details."
                id={tooltipId}
                styles={hostStyles}
            >
                <Stack horizontal styles={stackStyles} tokens={stackTokens}>
                    <CompletionIndicatorIcon
                        completionIndicator={
                            props.deployment.completionIndicator
                        }
                        completionIndicatorString={
                            props.deployment.completionIndicatorString
                        }
                        theme={theme}
                    />
                    <Link
                        style={{ paddingLeft: 5 }}
                        underline
                        onClick={() => onViewDetailsClick(props.deployment)}
                    >
                        {getCurrentStepName(props.replication)}
                    </Link>
                </Stack>
            </TooltipHost>
        ) : null;
    };
